export const roundCornerSize = {
    tiny: 2,
    small: 4,
    medium: 16,
    large: 26,
};
